/**
 * menuDesigns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const menuDesignsPack: ToilePack = {
    slug: 'menu-designs',
    category: 'menu',
    name: 'Menu designs',
    tagline: tagline('menus', 'venues', 'styles'),
    chips: chips('venues', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'brunch', label: 'The Copper Spoon', subject: 'a cafe brunch menu, two sections of short dish lines with prices'},
        {key: 'cocktail', label: 'Low Tide Bar', subject: 'a cocktail list, one column of short drink names with prices'},
        {key: 'pizzeria', label: 'Forno Sette', subject: 'a pizzeria menu, two columns of pizza names with prices'},
    ],
    styles: [
        {key: 'chalk', label: 'Chalk rustic', style: 'chalk rustic, hand-drawn flourishes', palette: 'white and pastel chalk on slate', framing: 'single vertical page, print-ready'},
        {key: 'serif', label: 'Elegant serif', style: 'elegant, a fine serif and thin rules', palette: 'cream paper, one gold accent', framing: 'single vertical page, wide margins'},
        {key: 'playful', label: 'Playful', style: 'playful illustrated, rounded hand-lettering', palette: 'bright flat colors, margin doodles', framing: 'single vertical page, print-ready'},
    ],
    directions: ['a wine list instead', 'in black and white only', 'shorter, fewer dishes'],
}
